export default __webpack_public_path__ + "media/MicrosoftFull.d0409a85.svg";